import { motion } from 'motion/react';
import { Sparkles, Clock, MessageCircle, Users, Heart, GraduationCap } from 'lucide-react';
import { CommunityFilter } from '../services/CommunityDiscoveryService';
// import { cn } from '../lib/utils';

import { useTheme } from './ThemeProvider';

interface FilterOption {
    id: CommunityFilter;
    label: string;
    icon: React.ElementType;
}

const FILTERS: FilterOption[] = [
    { id: 'trending', label: 'Trending', icon: Sparkles },
    { id: 'for_you', label: 'For You', icon: Heart },
    { id: 'newest', label: 'Newest', icon: Clock },
    { id: 'posts', label: 'Most Active', icon: MessageCircle },
    { id: 'members', label: 'Largest', icon: Users },
    { id: 'university', label: 'Universities', icon: GraduationCap },
];

interface CommunityFilterBarProps {
    selectedFilter: CommunityFilter;
    onFilterChange: (filter: CommunityFilter) => void;
    className?: string;
    /** Show the Universities tab — tribes only, never forums */
    showUniversityFilter?: boolean;
}

export function CommunityFilterBar({ selectedFilter, onFilterChange, className, showUniversityFilter = false }: CommunityFilterBarProps) {
    const { theme } = useTheme();
    const visibleFilters = showUniversityFilter ? FILTERS : FILTERS.filter(f => f.id !== 'university');

    return (
        <div className={`flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide ${className}`}>
            {visibleFilters.map((filter) => {
                const isSelected = selectedFilter === filter.id;
                const Icon = filter.icon;

                return (
                    <motion.button
                        key={filter.id}
                        whileTap={{ scale: 0.95 }}
                        onClick={() => onFilterChange(filter.id)}
                        className={`
              relative flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-all whitespace-nowrap shadow-sm
              ${isSelected
                                ? 'text-white border-none'
                                : 'bg-[#F2EFE9] dark:bg-[#2a2a2a] text-[#666666] dark:text-[#E5E5E5] border border-black/5 dark:border-white/10 hover:bg-[#EDE5D5] dark:hover:bg-white/5'
                            }
            `}
                        style={isSelected ? {
                            backgroundImage: theme === 'dark'
                                ? 'linear-gradient(135deg, #3B82F6 0%, #1D4ED8 100%)'
                                : 'linear-gradient(135deg, #F39C12 0%, #E74C3C 100%)'
                        } : undefined}
                    >
                        <div className="relative flex items-center gap-2">
                             <Icon className={`w-3.5 h-3.5 ${isSelected ? 'text-white' : 'text-[#999999] dark:text-[#E5E5E5]'}`} />
                             {filter.label}
                        </div>
                    </motion.button>
                );
            })}
        </div>
    );
}
